<mat-sidenav-container class="sidenav-container" [hasBackdrop]="false">
  <mat-sidenav
    #drawer
    id="sideNav"
    class="{{ navTheme }}"
    [ngClass]="{ sidenav: true, 'sidenav-extended': true }"
    fixedInViewport="true"
    role="navigation"
    mode="over"
    [opened]="true"
    [disableClose]="true"
    [autoFocus]="false"
  >
    <div class="sidebar-logo">
      <a [routerLink]="homeRoute" class="cursor">
        <img src="assets/images/CrosswareColourWhiteText.svg" width="140" height="40" />
      </a>
    </div>

    <mat-nav-list class="left-nav" style="border-top: none; padding-top: 36px">
      <a
        *ngIf="showSignatures"
        mat-list-item
        routerLink="/me/me-signature"
        title="Signatures"
        routerLinkActive="{{ activeTheme }}"
        [disableRipple]="true"
      >
        <img matListIcon class="nav-item-icon" src="assets/images/Signatures.svg" alt="" />
        <span mat-line>Signatures</span>
      </a>

      <a
        *ngIf="showUserAttributes"
        mat-list-item
        routerLink="/me/me-attributes"
        title="User Attributes"
        routerLinkActive="{{ activeTheme }}"
        [disableRipple]="true"
      >
        <img matListIcon class="nav-item-icon" src="assets/images/UserAttributes.svg" alt="" />
        <span mat-line>User Attributes</span>
      </a>

    </mat-nav-list>

    <div class="user-menu-section">
      <xware-user-menu></xware-user-menu>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
